(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('PublicController', PublicController);

    PublicController.$inject = ['$state', 'Principal'];

    function PublicController ($state, Principal) {
        var vm = this;

        vm.menuNavbarCollapsed = true;
        vm.searchValue = '';
        vm.toggleMenuNavbar = toggleMenuNavbar;
        vm.collapseMenuNavbar = collapseMenuNavbar;
        vm.scrollToTop = scrollToTop;
        vm.search = search;
        vm.$state = $state;
        vm.isAuthenticated = Principal.isAuthenticated;

        $(window).scroll(function(){
            if ($(this).scrollTop() > 200) {
                /* show header sticky */
                $('#header-sticky').addClass('sticky');
                $('#header-sticky').removeClass('hidden');
                $('#header-sticky').addClass('hidden-xs');
                /* show social network sticky */
                $('#social-network-sticky').addClass('sticky');
                $('#social-network-sticky').removeClass('hidden');
                $('#social-network-sticky').addClass('hidden-xs');
                /* show scroll top top */
                $('#scroll-to-top').fadeIn();

            } else {
                /* hide header sticky */
                $('#header-sticky').removeClass('sticky');
                $('#header-sticky').removeClass('hidden-xs');
                $('#header-sticky').addClass('hidden');
                /* hide social network sticky */
                $('#social-network-sticky').removeClass('sticky');
                $('#social-network-sticky').removeClass('hidden-xs');
                $('#social-network-sticky').addClass('hidden');

                /* hide scroll top top */
                $('#scroll-to-top').fadeOut();
            }
        });

        function toggleMenuNavbar() {
            vm.menuNavbarCollapsed = !vm.menuNavbarCollapsed;
        }

        function collapseMenuNavbar() {
            vm.menuNavbarCollapsed = true;
        }

        function scrollToTop() {
            $('html, body').animate({ scrollTop: 0 }, 600);
        };

        function search() {
            if (vm.searchValue !== undefined && vm.searchValue !== '') {
                window.location.replace('/gw/#/sistema-de-consulta/sitios?q=' + vm.searchValue);
            }
        }
    }
})();
